export type NewsItem = {
  id: number;
  title: string;
  summary: string;
  date: string;
  category: string;
  author: string;
  cover: string;
  content: string[];
};

export const newsList: NewsItem[] = [
  {
    id: 1,
    title: '北条麻妃新作《潮汐之间》入围亚洲电影展主竞赛单元',
    summary:
      '由小林绫执导、北条麻妃主演的《潮汐之间》正式入围本届亚洲电影展主竞赛单元，成为今年最受关注的华语地区亮相作品之一。',
    date: '2024-09-18',
    category: '影展',
    author: '编辑部',
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20cinematic%20wide%20shot%20of%20a%20film%20festival%20red%20carpet%20entrance%20at%20dusk%20with%20soft%20warm%20spotlights%20and%20a%20subtle%20deep%20indigo%20night%20sky%2C%20glamorous%20yet%20tasteful%20atmosphere%2C%20no%20recognizable%20faces%2C%20artistic%20editorial%20photo%2C%20high%20detail%2C%20refined%20color%20grading&width=800&height=500&seq=bhnews-01&orientation=landscape',
    content: [
      '本届亚洲电影展组委会于昨日公布了主竞赛单元的完整入围名单，由小林绫执导、北条麻妃领衔主演的《潮汐之间》赫然在列。这是两人继《东京雨夜》《夏日回声》之后的第三次合作。',
      '《潮汐之间》讲述一对因误会分开多年的恋人在海边小镇重逢的故事，影片以七天的时间跨度，细腻地描摹了重逢、坦白与释怀的全过程。评审团在评语中称赞其为"一部克制而深情的作品"。',
      '据片方透露，北条麻妃在片中几乎素颜出演，全程采用自然光拍摄，其中一场长达九分钟的岸边长镜头被誉为全片最具感染力的段落。',
      '影片将于影展期间进行亚洲首映，随后陆续在多地上映。更多排片信息请持续关注本站更新。',
    ],
  },
  {
    id: 2,
    title: '专访：北条麻妃谈《深海之光》中的表演突破',
    summary:
      '在《深海之光》之后，北条麻妃首次敞开心扉，聊了聊那段为角色潜水训练三个月的日子，以及她如何理解"记忆"这个主题。',
    date: '2024-08-02',
    category: '专访',
    author: '特约撰稿人',
    cover:
      'https://readdy.ai/api/search-image?query=Softly%20lit%20interview%20studio%20scene%20with%20two%20empty%20chairs%20facing%20each%20other%20and%20a%20warm%20desk%20lamp%2C%20cozy%20intimate%20conversational%20mood%2C%20muted%20amber%20and%20deep%20indigo%20tones%2C%20tasteful%20editorial%20photography%2C%20no%20readable%20text%2C%20high%20detail%2C%20refined%20composition&width=800&height=500&seq=bhnews-02&orientation=landscape',
    content: [
      '《深海之光》上映至今已近一年，但关于这部影片的讨论从未停止。女主角北条麻妃在片中饰演一位失忆的海洋生物学家，为了呈现真实的潜水状态，她提前三个月跟随专业教练进行训练。',
      '"最难的不是闭气，而是让身体记住那种在水下的放松感。"她在采访中说，"当周围完全安静下来，你会发现记忆不是被丢掉，只是沉到了更深的地方。"',
      '谈到与导演中岛美咲的合作，她表示对方很少给具体的表演指令，而是鼓励她"先感受，再表达"。这种信任让她在片场第一次尝试了长时间的即兴表演。',
      '对于接下来的计划，她透露希望尝试更多不同类型的角色，"不想被固定在一种形象里"。',
    ],
  },
  {
    id: 3,
    title: '《京都物语》4K 修复版将于下月特别重映',
    summary:
      '这部被誉为"写给京都的一封情书"的经典作品，将以全新 4K 修复版本重返大银幕，并附带幕后纪录片片段。',
    date: '2024-07-21',
    category: '重映',
    author: '放映情报',
    cover:
      'https://readdy.ai/api/search-image?query=Traditional%20Kyoto%20stone%20alley%20at%20dusk%20with%20wooden%20machiya%20houses%20and%20soft%20paper%20lantern%20glow%2C%20quiet%20nostalgic%20atmosphere%2C%20warm%20muted%20earth%20and%20deep%20indigo%20tones%2C%20tasteful%20cinematic%20composition%2C%20no%20readable%20text%2C%20high%20detail%2C%20refined%20color%20grading&width=800&height=500&seq=bhnews-03&orientation=landscape',
    content: [
      '发行方宣布，《京都物语》4K 修复版将于下月中旬在部分影院进行限定重映，这也是该片上映五年来首次以修复版本与观众见面。',
      '修复工作历时近一年，团队逐帧处理了原版底片上的划痕与噪点，同时尽可能保留了影片原有的胶片颗粒质感。导演渡边修全程参与了色彩校正。',
      '本次重映将额外附赠一段约二十分钟的幕后纪录片，收录了当年在京都实景拍摄的花絮与主创访谈。',
      '重映场次有限，感兴趣的影迷可通过本站资讯页持续关注后续排片安排。',
    ],
  },
  {
    id: 4,
    title: '北条麻妃携手导演佐藤健一，新片正式开机',
    summary:
      '继《夜色蝶影》与《逆流之河》之后，两人再度携手。新作暂定名为《潮声》，目前已在沿海小城开机。',
    date: '2024-06-30',
    category: '片场',
    author: '编辑部',
    cover:
      'https://readdy.ai/api/search-image?query=Coastal%20film%20set%20at%20dawn%20with%20camera%20equipment%20and%20tripods%20silhouetted%20against%20a%20soft%20pastel%20sea%20horizon%2C%20quiet%20anticipatory%20mood%2C%20warm%20amber%20and%20muted%20blue%20tones%2C%20tasteful%20behind%20the%20scenes%20editorial%20photo%2C%20no%20recognizable%20faces%2C%20high%20detail&width=800&height=500&seq=bhnews-04&orientation=landscape',
    content: [
      '据片方公布的消息，北条麻妃与导演佐藤健一合作的第三部作品《潮声》已于本月正式开机。这也是两人时隔三年后的再度携手。',
      '影片将延续佐藤健一一贯的作者风格，以一座海边小城为背景，讲述几位普通人在一次意外之后彼此重新连接的故事。',
      '为贴近角色，北条麻妃提前一个月入住当地，学习方言并体验当地生活。她在开机仪式上表示，希望这次能带来"完全不同的一种表演"。',
      '影片预计于明年与观众见面，更多动态本站将持续跟进。',
    ],
  },
  {
    id: 5,
    title: '盘点：北条麻妃近年十部代表性作品',
    summary:
      '从《樱花残照》到《潮汐之间》，我们整理了这十年间最能体现她表演跨度与成长的十部作品。',
    date: '2024-05-12',
    category: '盘点',
    author: '影迷编辑部',
    cover:
      'https://readdy.ai/api/search-image?query=Flat%20lay%20of%20several%20blank%20vintage%20film%20poster%20frames%20arranged%20neatly%20on%20a%20dark%20wooden%20table%20with%20a%20warm%20desk%20lamp%2C%20collector%20and%20curation%20mood%2C%20muted%20amber%20and%20deep%20indigo%20tones%2C%20tasteful%20editorial%20photography%2C%20no%20readable%20text%2C%20high%20detail&width=800&height=500&seq=bhnews-05&orientation=landscape',
    content: [
      '如果要选出一部让北条麻妃真正被更多观众记住的作品，很多人会投给《樱花残照》。她在片中饰演的家族小女儿，既有少女的倔强，也有成年人的隐忍。',
      '此后她陆续尝试了悬疑、动作、喜剧等不同题材。《逆流之河》里的运动员、《霓虹尽头》中的调查记者、《春日慢行》中学会慢下来的都市白领，每一次都不是重复自己。',
      '而《深海之光》与《京都物语》则让人看到她驾驭大银幕的能力，前者的沉静、后者的厚重，构成了她表演光谱的两端。',
      '本文所列为编辑部的整理与推荐，完整片单可在"电影分类"页中按类型与年份进一步筛选查看。',
    ],
  },
  {
    id: 6,
    title: '《霓虹尽头》斩获年度最佳摄影奖',
    summary:
      '凭借极具风格的夜景摄影，《霓虹尽头》在今年的行业评选活动中拿下最佳摄影大奖，导演园子温出席领奖。',
    date: '2024-04-08',
    category: '获奖',
    author: '编辑部',
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20urban%20night%20alley%20glowing%20with%20sign%20lights%20reflected%20on%20rain%20slicked%20pavement%2C%20cinematic%20neo%20noir%20atmosphere%2C%20deep%20blue%20shadows%20with%20warm%20orange%20glow%2C%20no%20recognizable%20text%2C%20tasteful%20editorial%20photo%2C%20high%20detail%2C%20refined%20color%20grading&width=800&height=500&seq=bhnews-06&orientation=landscape',
    content: [
      '在今年的行业评选活动中，《霓虹尽头》的摄影指导凭借对城市夜景的独特处理获得最佳摄影大奖。评委会特别提到影片中"光与影的呼吸感"。',
      '影片几乎全部采用实景拍摄，团队花了大量时间研究不同街道在雨夜中的反光规律，许多镜头都只用了自然存在的城市光源。',
      '导演园子温在领奖时表示："这座城市本身就是最好的布景，我们只是把它诚实地记录下来。"',
      '《霓虹尽头》目前仍可在本站电影分类页中查看详细的剧情与制作信息。',
    ],
  },
  {
    id: 7,
    title: '北条麻妃出席东京国际电影节红毯',
    summary:
      '以《浮世绘卷》主创身份亮相开幕红毯，一袭深蓝礼服成为当晚媒体的焦点之一。',
    date: '2024-03-15',
    category: '活动',
    author: '现场报道',
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20evening%20red%20carpet%20entrance%20with%20soft%20photographer%20flash%20bokeh%20and%20a%20deep%20indigo%20night%20backdrop%2C%20glamorous%20stage%20lighting%2C%20warm%20amber%20accents%2C%20tasteful%20event%20editorial%20photo%2C%20no%20recognizable%20faces%20or%20text%2C%20high%20detail%2C%20refined%20color%20grading&width=800&height=500&seq=bhnews-07&orientation=landscape',
    content: [
      '东京国际电影节开幕当晚，北条麻妃随《浮世绘卷》主创团队走上红毯。她一袭深蓝色礼服，与影片中的浮世绘色调遥相呼应。',
      '在随后的媒体见面会上，她谈到了拍摄《浮世绘卷》时学习传统绘画工艺的经历，并表示这段准备过程让她"重新理解了匠人精神"。',
      '本届电影节期间，《浮世绘卷》进行了两场特别展映，映后交流均座无虚席。',
    ],
  },
  {
    id: 8,
    title: '影迷特辑：北条麻妃演绎过的经典女性角色',
    summary:
      '从舞台上的失意演员到深海中寻找记忆的学者，我们回顾了她塑造过的那些令人难忘的女性形象。',
    date: '2024-02-06',
    category: '特辑',
    author: '影迷编辑部',
    cover:
      'https://readdy.ai/api/search-image?query=Artistic%20wall%20of%20empty%20framed%20portrait%20outlines%20in%20a%20quiet%20gallery%20with%20soft%20directional%20lighting%2C%20contemplative%20curatorial%20mood%2C%20muted%20amber%20and%20deep%20indigo%20tones%2C%20tasteful%20editorial%20photography%2C%20no%20readable%20text%2C%20high%20detail&width=800&height=500&seq=bhnews-08&orientation=landscape',
    content: [
      '优秀的表演往往藏在细节里。回顾北条麻妃近年的作品，会发现她塑造的女性角色很少有雷同：她们安静，但并不软弱；她们犹豫，却从不逃避。',
      '《夜色蝶影》里的剧场演员，把梦想藏在每一次谢幕里；《无声告白》里的摄影师，用镜头代替语言；《潮汐之间》里的恋人，则用七天时间学会了放下。',
      '这种跨度，正是她作为演员最珍贵的地方。本文仅作整理与分享，希望更多观众能通过作品认识她。',
    ],
  },
];

export const getNewsById = (id: number): NewsItem | undefined =>
  newsList.find((n) => n.id === id);

export const getRelatedNews = (item: NewsItem, limit = 3): NewsItem[] =>
  newsList.filter((n) => n.id !== item.id).slice(0, limit);